<template>
	<div>
		<div class="p-text-center">
			<h1 class="p-text-bold p-my-0">
				Step 4: Parent & Emergency Contact Information
			</h1>

			<p class="p-mt-2">Please fill out your information below.</p>
		</div>

		<div class="p-fluid p-grid p-formgrid p-text-left p-jc-center">
			<div class="p-col-12 p-md-6 p-mt-3">
				<h4 class="p-text-bold p-text-center p-mb-0">
					Parent/Legal Guardian Information
				</h4>

				<div
					v-for="(parentData, index) in this.store.ParentInformation"
					:key="index"
					class="p-mt-4"
				>
					<div>
						<ParentInfo
							:parentData="parentData"
							:parentIndex="index"
							:validateForm="validateForms"
							:validateAllForms="validateAllForms"
							@removeBlock="removeParentBlock"
						/>
					</div>
				</div>

				<Button
					label="Add Another Parent"
					class="p-button-primary p-button-raised p-button-outlined p-mt-3 p-mb-2"
					icon="pi pi-plus"
					@click="addParentBlock"
				/>

				<small
					v-if="store.ParentInformation.length === 0 && submitted"
					class="p-error"
				>
					At least one parent information is required.
				</small>
			</div>

			<div class="p-col-12 p-md-6 p-mt-3">
				<h4 class="p-text-bold p-text-center p-mb-0">
					Emergency/Alternate Contacts
				</h4>

				<div
					v-for="(emergencyContactData, index) in this.store
						.EmergencyContactInfo"
					:key="index"
					class="p-mt-4"
				>
					<div>
						<EmergencyContactInfo
							:emergencyContactData="emergencyContactData"
							:emergencyContactIndex="index"
							:validateForm="validateForms"
							:validateAllForms="validateAllForms"
							@removeBlock="removeEmerContBlock"
						/>
					</div>
				</div>

				<Button
					label="Add Another Contact"
					class="p-button-primary p-button-raised p-button-outlined p-mt-3 p-mb-2"
					icon="pi pi-plus"
					@click="addEmerContBlock"
				/>

				<small
					v-if="store.EmergencyContactInfo.length === 0 && submitted"
					class="p-error"
				>
					At least one emergency/alternate contact information is required.
				</small>
			</div>
		</div>

		<div class="p-d-flex p-jc-between p-mt-3 p-no-gutters">
			<div class="p-mb-3 p-col-6 p-pl-0">
				<Button
					label="Back"
					icon="pi pi-angle-left"
					class="p-button-secondary"
					style="min-width: 120px; max-width: 120px"
					@click="prevStep"
				/>
			</div>

			<div class="p-mb-3 p-col-6 p-pr-0">
				<Button
					label="Next"
					icon="pi pi-angle-right"
					iconPos="right"
					style="min-width: 120px; max-width: 120px"
					@click="nextStep"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";
import { useVuelidate } from "@vuelidate/core";
import ParentInfo from "../blocks/ParentInfo.vue";
import EmergencyContactInfo from "../blocks/EmergencyContactInfo.vue";

export default {
	name: "ParentInformation",
	data() {
		return {
			validateForms: 0,

			numOfParents: 1,
			numOfEmergencyContact: 1,

			allParentFormStates: [],
			allEmergencyContactFormStates: [],

			parentValidated: false,
			emergContactValidated: false,

			submitted: false,
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
			v$: useVuelidate(),
		};
	},
	watch: {},
	created() {},
	methods: {
		addParentBlock() {
			this.store.ParentInformation.push({
				firstName: null,
				lastName: null,
				phone2: null,
				phone: null,
				relationship: null,
			});
		},
		removeParentBlock(index) {
			this.store.ParentInformation.splice(index, 1);

			this.allParentFormStates.splice(index, 1);
		},
		addEmerContBlock() {
			this.store.EmergencyContactInfo.push({
				firstName: null,
				lastName: null,
				phone2: null,
				phone: null,
				relationship: null,
			});
		},
		removeEmerContBlock(index) {
			this.store.EmergencyContactInfo.splice(index, 1);

			this.allEmergencyContactFormStates.splice(index, 1);
		},
		validateAllForms(validForm, index, formType) {
			let validStates = [];

			if (formType === "parent") {
				this.allParentFormStates[index] = validForm;
				validStates = Object.values(this.allParentFormStates);
			} else if (formType === "emergencyContact") {
				this.allEmergencyContactFormStates[index] = validForm;
				validStates = Object.values(this.allEmergencyContactFormStates);
			}

			let allFormsValid = true;
			let numOfForms =
				formType === "parent"
					? this.store.ParentInformation.length
					: this.store.EmergencyContactInfo.length;

			if (validStates.length !== numOfForms || validStates.includes(false)) {
				allFormsValid = false;
			}

			if (!allFormsValid) {
				this.scrollToFirstError();
			} else {
				if (formType === "parent") {
					this.store.ParentSummary = {
						numOfParents: this.numOfParents,
						numOfEmergencyContact: this.numOfEmergencyContact,
					};

					this.parentValidated = true;
				} else if (formType === "emergencyContact") {
					this.store.ParentSummary = {
						numOfEmergencyContact: this.numOfEmergencyContact,
						numOfParents: this.numOfParents,
					};

					this.emergContactValidated = true;
				}
			}

			if (this.parentValidated && this.emergContactValidated) {
				this.$emit("nextStep");
			}
		},
		nextStep() {
			this.submitted = true;
			this.parentValidated = false;
			this.emergContactValidated = false;
			this.allParentFormStates = [];
			this.allEmergencyContactFormStates = [];

			for (let i = 0; i < this.store.ParentInformation.length; i++) {
				this.allParentFormStates.push(false);
			}

			for (let i = 0; i < this.store.EmergencyContactInfo.length; i++) {
				this.allEmergencyContactFormStates.push(false);
			}

			this.validateForms += 1;
		},
		prevStep() {
			this.$emit("prevStep");
		},
		scrollToFirstError() {
			this.$nextTick(() => {
				if (document.querySelector(".p-error")) {
					let domRect = document
						.querySelector(".p-error")
						.getBoundingClientRect();
					window.scrollTo({
						left: domRect.left + document.documentElement.scrollLeft,
						top: domRect.top + document.documentElement.scrollTop - 100,
						behavior: "smooth",
					});
				}
			});
		},
		searchProvinceState() {
			this.filteredProvinceState = [];
		},
	},
	components: { ParentInfo, EmergencyContactInfo },
};
</script>

<style lang="scss" scoped></style>
